// extracted by mini-css-extract-plugin
module.exports = {"container":"Base_container__3gyM7","expandOverlay":"Base_expandOverlay__1n6r5"};